enum TreasuresView {
  CARD,
  MAP,
}

export default TreasuresView;
